export const USER_PATHS = {
	PROFILE: '/uzytkownik/profil',
	DEVICES: '/uzytkownik/urzadzenia',
	PRODUCTS: '/uzytkownik/aktywne-wypozyczenia',
	PACKETS: '/uzytkownik/twoje-pakiety',
	FAVOURITES: '/uzytkownik/ulubione',
	PAYMENTS: '/uzytkownik/historia-platnosci',
	PAYMENT_METHOD: '/uzytkownik/metoda-platnosci',
	DOCUMENTS: '/uzytkownik/dokumenty',
	AGREEMENTS: '/uzytkownik/zgody',
	REGULATIONS: '/uzytkownik/regulamin',
	ALIAS: '/uzytkownik/:alias'
};
